<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">组织结构维护</div>
    </zj-layout-header>
    <zj-layout-main>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
        <el-form-item label="应急组织类型" prop="organizationType" style="display:inline-block;">
          <el-select
            v-model="ruleForm.organizationType"
            placeholder="请选择所属应急组织类型"
            v-bind:disabled="IsEdit"
            style="width:118rem;"
          >
            <el-option
              v-for="item in options"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组织性质" prop="organizationNature" style="display:inline-block;">
          <el-radio-group
            v-model="ruleForm.organizationNature"
            style="width:118rem;"
            v-bind:disabled="IsEdit"
          >
            <el-radio
              v-for="item in options1"
              :key="item.code"
              :label="item.code"
              :value="item.code"
            >{{item.value}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="应急组织名称" prop="name" style="display:inline-block;">
          <el-input v-model="ruleForm.name" style="width:118rem;" v-bind:disabled="IsEdit"></el-input>
        </el-form-item>
      </el-form>
    </zj-layout-main>
    <zj-layout-footer>
      <div style="text-align:center;width:134rem;padding:1rem 1rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
        <el-button @click="resetForm()" v-show="IsEdit==false">重置</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import ZJApp from '../../../../../app';
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { save, update, detail } from "@/api/src/emergency_organization";

export default {
  name: "ZjPersonOrganiztioninfo",
  controller: "EmergencyResource",
  action: "PersonOrganiztioninfo",
  props: {
    query: {
      type: String,
      id: String
    }
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中',
      ruleForm:{
        organizationType:'',
        organizationNature:'',
        name:'',
      },
      options: [],
      options1: [],
      rules: {
        name: [
          { required: true, message: "请输入应急组织名称", trigger: "blur" }
        ],
        organizationType: [
          { required: true, message: "请选择所属应急组织类型", trigger: "change" }
        ],
        organizationNature: [
          { required: true, message: "请选择组织性质", trigger: "change" }
        ],

        IsEdit: false
        //desc: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  created: function() {
    this.basedatabind();
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  mounted: function() {},
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        this.ruleForm = {
          organizationType:'',
          organizationNature:'',
          name:'',
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        getDictionary('organization_type'),
        getDictionary('organization_nature'),
      ])
      .then(r => {
        this.options = r[0].data.records;
        this.options1 = r[1].data.records;
        this.loading = false;
        return r;
      })
      .catch(e => {
        console.error(e);
        this.loading = false;
      });
    },
    search() {
      let { id } = this.query;
      if (id != null && id != "") {
        this.loading = true;
        this.loadingText = '加载中...';
        detail( id )
          .then(r => {
            r = r.data;
            this.ruleForm = r;
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //重置
    resetForm() {
      this.ruleForm = {
        organizationType:'',
        organizationNature:'',
        name:'',
      };
      this.query.id = null;
    },
    save() {
      if (this.query.id == null || this.query.id == "") {
        this.loading = true;
        this.loadingText = '保存中...';
        save(this.ruleForm)
          .then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.loadingText = '保存中...';
        update(this.ruleForm)
          .then(r => {
            r = r.data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.loading = false;
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    }
  }
};
</script>